export default __webpack_public_path__ + "../staticImages/wsh_geschenke_gold-260.png";